import { getUserData } from '@/auth/utils'
import { $themeConfig } from '@themeConfig'
const resource = import.meta.env.PROD?null:'assets/images/logo'
// Use for dynamics logos from resources/js/src/
export function getImageUrl(asset) {
    let path = `${resource?`${resource}/`:''}${asset}`
    return new URL(path, import.meta.url).href
}
// Use for dynamics logos from resources/js/src/assets/images/logo
export function getCompanyLogoUrl() {
    if (getUserData().logo) {
        let path = `${resource?`${resource}/`:''}${getUserData().logo}`
        return new URL(path, import.meta.url).href
    } else {
        return $themeConfig.logos.logoSP
    }
}
